import { render, staticRenderFns } from "./ItemFilterModalFilter.vue?vue&type=template&id=09f8e0c4&scoped=true"
import script from "./ItemFilterModalFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterModalFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f8e0c4",
  null
  
)

export default component.exports